import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { firstUserErrorCode } from '@/graphql/errors';
import { CREATE_WORKSPACE } from '@/graphql/mutations/workspace';
import { track } from '@/shared/lib/analytics';

export type CreateWorkspaceOutcome = { isCreated: true } | { isCreated: false; errorCode: string };

type UseCreateWorkspaceResult = {
  createWorkspace: (name: string) => Promise<CreateWorkspaceOutcome>;
};

export function useCreateWorkspace(): UseCreateWorkspaceResult {
  const [mutate] = useMutation(CREATE_WORKSPACE);

  const createWorkspace = useCallback(
    async (name: string): Promise<CreateWorkspaceOutcome> => {
      const { data } = await mutate({ variables: { input: { name } } });
      const payload = data?.createWorkspace;
      if (payload?.workspace) {
        track('sign_up');
        return { isCreated: true };
      }
      return { isCreated: false, errorCode: firstUserErrorCode(payload?.userErrors) ?? 'UNKNOWN' };
    },
    [mutate],
  );

  return { createWorkspace };
}
